<template>
  <div class="more-knowedge">
    <common-bg-plate>
      <change-chain></change-chain>
      <div class="user-content">
        <bulletproofs ref="bulletproofs"></bulletproofs>
      </div>
    </common-bg-plate>
  </div>
</template>
<script>
import changeChain from '../../privacyComputing/components/changeChain.vue'
import bulletproofs from '../../blockchain/bulletproofs/index'
export default {
  components: {
    changeChain,
    bulletproofs
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('more-knowedge', (), ());
.more-knowedge {
  @include adaptation(
    (
      --more-knowedge-user-content-padding: 24px 20px
    )
  );
  --more-knowedge-min-height: var(--base-main-router-body-avaliable-height);
  .common-bg-plate {
    min-height: var(--more-knowedge-min-height);
    .user-content {
      padding: var(--more-knowedge-user-content-padding);
    }
  }
}
</style>
